export function redirect(url) {
    window.location.href = url;
}